import { Button } from 'base/ui/button';
import { Dialog } from 'base/ui/dialog';
import { getLimitErrorDialog } from 'base/ui/error_dialogs';
import { TextRegularLight } from 'base/ui/typography';
import { CrawlError } from 'blocks/blocks_service';
import * as React from 'react';
import styles from './sitemap_import_error_dialog.css';

type SitemapImportErrorDialogProps = {
  // Using `unknown` because in Typescript we cannot specify
  // the error type in the `catch` clause.
  error: unknown;
  onClose: () => void;
};

export function SitemapImportErrorDialog({
  error,
  onClose,
}: SitemapImportErrorDialogProps) {
  const LimitErrorDialog = getLimitErrorDialog(error);
  if (LimitErrorDialog) {
    return <LimitErrorDialog onClose={onClose} />;
  }

  const message =
    error instanceof CrawlError && error.message !== ''
      ? error.message
      : 'We encountered an issue while importing your sitemap.';

  return (
    <Dialog
      title="Error importing sitemap"
      onClose={onClose}
      buttons={
        <Button
          label="Close"
          variant="primary"
          onClick={onClose}
          size="large"
        />
      }
    >
      <TextRegularLight>{message}</TextRegularLight>
      <TextRegularLight>
        Please give it another try, or{' '}
        <a
          href="https://slack.relume.io"
          className={styles.supportLink}
          target="_blank"
          rel="noreferrer"
        >
          join our Slack
        </a>{' '}
        for further assistance.
      </TextRegularLight>
    </Dialog>
  );
}
